// extracted by mini-css-extract-plugin
export default {"totalLayout":"AddVastraType_totalLayout__Xrb2B","SubHeading":"AddVastraType_SubHeading__zU63d","tableContainer":"AddVastraType_tableContainer__bAxmk"};